import React from "react";
import { Control, Controller } from "react-hook-form";
import { matchIsValidTel, MuiTelInput } from "mui-tel-input";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  type?: "text" | "password" | "email" | "number" | "tel";
}

const FormPhoneField: React.FC<Props> = (props) => {
  const { control, fieldName, label, required, disabled } = props;

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        validate: (value) =>
          required || value
            ? matchIsValidTel(value, { onlyCountries: ["US"] })
            : true,
        required: {
          value: required!,
          message: "Required",
        },
      }}
      render={({
        field: { onChange, value, ref: fieldRef, ...fieldProps },
        fieldState: { error, invalid },
        formState,
      }) => (
        <MuiTelInput
          {...fieldProps}
          fullWidth
          label={label}
          helperText={invalid ? "Invalid" : error?.message ?? null}
          inputRef={fieldRef}
          onlyCountries={["US"]}
          error={!!error || invalid}
          onChange={onChange}
          value={value || ""}
          variant="outlined"
          disabled={disabled}
          defaultCountry="US"
          forceCallingCode
          disableDropdown
          disableFormatting
        />
      )}
    />
  );
};

export default FormPhoneField;
